import { Tournament } from 'types'

const tournamentWhitelist = ['sportradar.dhbdata.16059', 'sportradar.dhbdata.16466']

export const isTournamentInLiveWhitelist = (tournament: Tournament): boolean => {
  return tournamentWhitelist.includes(tournament.id)
}
